module.exports = __webpack_public_path__ + "img/534.aadfa232.jpg";